import React from 'react';

export default function AboutModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fadeIn">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl max-w-xl w-full p-8 relative shadow-2xl text-left space-y-4 max-h-[85vh] overflow-y-auto">
        <button 
          onClick={onClose}
          className="absolute top-5 right-5 text-slate-400 hover:text-white font-bold text-xl bg-slate-800 w-8 h-8 rounded-full flex items-center justify-center transition cursor-pointer"
          aria-label="Cerrar modal"
        >
          ✕
        </button>

        <div className="flex items-center space-x-3">
          <div className="bg-blue-600 text-white font-black p-2 rounded-xl text-sm">EOH</div>
          <div>
            <h3 className="text-2xl font-bold text-white">Acerca de English EOH</h3>
            <p className="text-xs text-blue-400 font-medium">Plataforma Educativa Oficial 2026</p>
          </div>
        </div>
        <hr className="border-slate-800" />

        <div className="text-xs space-y-3 text-slate-300 leading-relaxed">
          <p>
            <strong>English EOH</strong> es el ecosistema inteligente de aprendizaje del idioma inglés diseñado exclusivamente para los estudiantes de básica secundaria (Grados 6°, 7° y 9°) de la <strong>Institución Educativa Enrique Olaya Herrera</strong> en Medellín, Colombia.
          </p>
          <div className="bg-slate-950 p-4 rounded-xl border border-slate-800 space-y-1">
            <p><strong>👨‍🏫 Director y Diseñador:</strong> Lic. Didier Antonio Alvarez Ramos, M.Sc. en Gestión de la Tecnología Educativa.</p>
            <p><strong>📧 Correo de Contacto:</strong> <a href="mailto:didier.alvarez@medellin.edu.co" className="text-blue-400 font-bold hover:underline">didier.alvarez@medellin.edu.co</a></p>
            <p><strong>🏫 Sede Institucional:</strong> Barrio Manrique Oriental, Medellín - Antioquia.</p>
            <p><strong>🎯 Modelo Pedagógico:</strong> Social-Cognitivo, Task-Based Learning (TBL) y Gramática en Contexto.</p>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-2.5 rounded-xl transition text-xs mt-2 cursor-pointer"
        >
          Cerrar Ventana
        </button>
      </div>
    </div>
  );
}
